import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { PagingParams, PaginationUtil } from './pagination-util.service';

@Injectable({ providedIn: 'root' })
export class ResolvePagingParams implements Resolve<PagingParams> {
  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): PagingParams {
    const page = route.queryParamMap.get('page');
    const defaultSort = route.data['defaultSort'] ?? 'id,asc';
    const sort = route.queryParamMap.get('sort') ?? defaultSort;
    return {
      page: this.paginationUtil.parsePage(page),
      predicate: this.paginationUtil.parsePredicate(sort),
      ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}
